import { schema } from 'normalizr'

const restaurantMenu = new schema.Entity('restaurantMenus')

export default restaurantMenu
